import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import Utils from "@teamprevent/common/utils";

import {
    matchEmployeeToEmployeeRecordSuccess,
    matchEmployeeToNewEmployeeRecordSuccess,
    loadPartiallyMatchedEmployeeDetailSuccess
} from "../common/actions";

import PartiallyMatchedFastTrackPitPupMedicalFormApi from "./partiallyMatchedFastTrackPitPupMedicalFormApi";
import {
    LOAD_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL,
    MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_EMPLOYEE_RECORD,
    MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_NEW_EMPLOYEE_RECORD,
    RERUN_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL
} from "./actionTypes";

import { push } from "redux-little-router";

export function matchFastTrackPitPupMedicalFormToEmployeeRecord(
    customerId: string,
    referralId: string,
    employeeRecordCustomerId: string,
    employeeRecordId: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_EMPLOYEE_RECORD,
            PartiallyMatchedFastTrackPitPupMedicalFormApi.match(
                customerId,
                referralId,
                employeeRecordCustomerId,
                employeeRecordId)
        );

        Utils.CheckResponse(result);

        if (result.success) {
            dispatch(matchEmployeeToEmployeeRecordSuccess({}));
            dispatch(push("/partiallyMatchedEmployees"));
        }
    };
}

export function matchFastTrackPitPupMedicalFormToNewEmployeeRecord(customerId: string, referralId: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            MATCH_FAST_TRACK_PIT_PUP_MEDICAL_FORM_TO_NEW_EMPLOYEE_RECORD,
            PartiallyMatchedFastTrackPitPupMedicalFormApi.matchToNewEmployeeRecord(customerId, referralId)
        );

        Utils.CheckResponse(result);

        if (result.success) {
            dispatch(matchEmployeeToNewEmployeeRecordSuccess({}));
            dispatch(push("/partiallyMatchedEmployees"));
        }
    };
}

export function loadPartiallyMatchedFastTrackPitPupMedicalFormDetail({
    customerId,
    referralId
}: { customerId: string; referralId: string }) {
    return async (dispatch: Dispatch) => {
        const rawResult = await loadAndTrack(
            dispatch,
            LOAD_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL,
            PartiallyMatchedFastTrackPitPupMedicalFormApi.detail(customerId, referralId)
        );

        const result = Utils.CheckResponse(rawResult);

        dispatch(loadPartiallyMatchedEmployeeDetailSuccess(result));
    };
}

export function rerunPartiallyMatchedFastTrackPitPupMedicalFormDetail(customerId: string, referralId: string) {
    return async (dispatch: Dispatch) => {
        const rawResult = await loadAndTrack(
            dispatch,
            RERUN_PARTIALLY_MATCHED_FAST_TRACT_PIT_PUP_MEDICAL_FORM_DETAIL,
            PartiallyMatchedFastTrackPitPupMedicalFormApi.rerun(customerId, referralId)
        );

        const result = Utils.CheckResponse(rawResult);

        dispatch(loadPartiallyMatchedEmployeeDetailSuccess(result));
    };
}
